interface AnalysisProps {
  language: 'pt' | 'en';
}

export default function Analysis({ language }: AnalysisProps) {
  const content = {
    pt: {
      eyebrow: 'O que será analisado',
      title: 'Estrutura do Diagnóstico',
      subtitle: 'Cada análise é conduzida com rigor técnico e foco em viabilidade real.',
      stepLabel: 'PASSO',
      items: [
        {
          number: '01',
          title: 'Objetivo e Horizonte',
          description: 'Identificação do propósito da aquisição, prazo desejado e capacidade de comprometimento mensal.'
        },
        {
          number: '02',
          title: 'Cenários Disponíveis',
          description: 'Mapeamento de grupos ativos, taxas de administração, histórico de contemplações e estratégias de lance.'
        },
        {
          number: '03',
          title: 'Viabilidade Financeira',
          description: 'Análise de fluxo de caixa, comparação com financiamento tradicional e projeção de custo efetivo total.'
        },
        {
          number: '04',
          title: 'Riscos e Mitigação',
          description: 'Avaliação de inadimplência do grupo, solidez da administradora e cláusulas contratuais críticas.'
        },
        {
          number: '05',
          title: 'Estratégia de Execução',
          description: 'Definição de timing de entrada, estratégia de lance (se aplicável) e próximos passos operacionais.'
        }
      ]
    },
    en: {
      eyebrow: 'What will be analyzed',
      title: 'Assessment Structure',
      subtitle: 'Each analysis is conducted with technical rigor and focus on real feasibility.',
      stepLabel: 'STEP',
      items: [
        {
          number: '01',
          title: 'Objective and Timeframe',
          description: 'Identification of acquisition purpose, desired timeline and monthly commitment capacity.'
        },
        {
          number: '02',
          title: 'Available Scenarios',
          description: 'Mapping of active groups, administration fees, award history and bidding strategies.'
        },
        {
          number: '03',
          title: 'Financial Feasibility',
          description: 'Cash flow analysis, comparison with traditional financing and total effective cost projection.'
        },
        {
          number: '04',
          title: 'Risks and Mitigation',
          description: 'Assessment of group default, administrator solidity and critical contractual clauses.'
        },
        {
          number: '05',
          title: 'Execution Strategy',
          description: 'Definition of entry timing, bidding strategy (if applicable) and next operational steps.'
        }
      ]
    }
  };

  const t = content[language];

  return (
    <section id="analysis" className="bg-[#FBF8F3] border-b border-[#E7E1D9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24">
        <div className="max-w-2xl mb-16">
          <h2 className="text-sm uppercase tracking-widest text-[#2E2E2E] mb-6 font-semibold">
            {t.eyebrow}
          </h2>
          <p className="text-4xl lg:text-5xl font-semibold text-[#0B0B0B] leading-tight mb-4">
            {t.title}
          </p>
          <p className="text-lg text-[#2E2E2E]">
            {t.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {t.items.map((item, index) => (
            <div
              key={index}
              className="border border-[#E7E1D9] bg-white p-8 hover:border-[#F97700] transition-colors duration-300 flex flex-col"
            >
              {/* Large step number */}
              <div className="flex items-start justify-between mb-6">
                <span className="text-6xl font-bold font-mono text-[#F97700]/20 leading-none select-none">
                  {item.number}
                </span>
                <span className="text-xs font-mono text-[#F97700] bg-[#F97700]/10 px-2 py-1 rounded font-semibold tracking-wider">
                  {t.stepLabel} {item.number}
                </span>
              </div>
              {/* Divider */}
              <div className="w-8 h-0.5 bg-[#F97700] mb-5" />
              <h3 className="text-xl font-semibold text-[#0B0B0B] mb-3">
                {item.title}
              </h3>
              <p className="text-base text-[#2E2E2E] leading-relaxed flex-1">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}